export enum TOOLTIP_HORIZONTAL_ALIGNMENTS {
  LEFT = "Left",
  RIGHT = "Right",
  CENTER = "Center",
}

export const generateRandomIdForAria = () => {
  return (Math.random() + 1).toString(36).substring(7);
};
